export default __webpack_public_path__ + "static/media/theme5.fad923c0.png";